import { CLASS_ACTIVE } from '../constants/classes';

// Internal class
const CLASS_IS_OVERFLOWING = 'is-overflowing';

/**
 * Checks an element to see if it is overflowing or not
 * @param element The html element to check the overflow of
 * @returns A true or false boolean value based on the overflow status
 */
export const checkOverflow = (element: HTMLElement) => {
  const currentOverflow = element.style.overflow;

  // Temporarily to check overflow status
  if (!currentOverflow || currentOverflow === 'visible') {
    element.style.overflow = 'hidden';
  }

  // Is the element overflowing?
  const isOverflowing =
    element.clientWidth < element.scrollWidth ||
    element.clientHeight < element.scrollHeight;

  // Set the overflow type back to its original status
  element.style.overflow = currentOverflow;

  return isOverflowing;
};

/**
 * Sets an overflow class on an elements container based on whether the element
 * is overflowing or not
 * @param element The element to decide on whether to set the overflow class or not
 * @param containerSelector The container selector string to use to find the
 * elements container
 */
export const setOverflowClass = (
  element: HTMLElement,
  containerSelector: string
) => {
  const container = element.closest<HTMLElement>(containerSelector);
  if (!container) return;

  if (checkOverflow(element)) {
    container.classList.add(CLASS_IS_OVERFLOWING);
  } else {
    container.classList.remove(CLASS_IS_OVERFLOWING);
  }
};

/**
 * Setups up mouse dragging for overflow elements
 * @param element Html element to initialise
 */
export const initMouseDragging = (element: HTMLElement) => {
  // Setup the desktop scrolling events
  let isDown = false;
  let startX: number;
  let scrollLeft: number;

  element.addEventListener('mousedown', (evt) => {
    isDown = true;
    element.classList.add(CLASS_ACTIVE);
    startX = evt.pageX - element.offsetLeft;
    scrollLeft = element.scrollLeft;
  });

  element.addEventListener('mouseleave', () => {
    isDown = false;
    element.classList.remove(CLASS_ACTIVE);
  });

  element.addEventListener('mouseup', () => {
    isDown = false;
    element.classList.remove(CLASS_ACTIVE);
  });

  element.addEventListener('mousemove', (evt) => {
    if (!isDown) return;
    evt.preventDefault();
    const x = evt.pageX - element.offsetLeft;
    const walk = (x - startX) * 3;
    element.scrollLeft = scrollLeft - walk;
  });
};
